import {
    ExIconButton,
    ExInput,
    IconButtonFlavor,
    IconButtonType,
    InputFooterType,
    SearchFlavor,
    SearchSize,
} from '@boomi/exosphere';
import { useRef } from 'react';

import './autosize-input.css';

interface Props {
    placeholder: string;
    value: string;
    icon?: string | null;
    testId?: string | null;
    invalid: boolean;
    onUpdate: (value: string) => void;
}

const AutosizeInput = ({
    placeholder,
    value,
    icon,
    testId = 'autosizeInput',
    invalid,
    onUpdate,
}: Props) => {
    const sizeCalibration = useRef<HTMLSpanElement | null>(null);
    const autosizeInputRef = useRef(null);

    return (
        <div className="autosize-input">
            <span className="autosize-input-size-calibration" ref={sizeCalibration}>
                {value}
            </span>
            <ExInput
                ref={autosizeInputRef}
                data-testId={testId}
                className="autosize-input-text-field"
                placeholder={placeholder}
                input-id="default"
                type="text"
                footerType={InputFooterType.INFO}
                inputmode="text"
                size={SearchSize.MEDIUM}
                flavor={SearchFlavor.WHITE}
                invalid={invalid}
                value={value}
                onInput={(e) => {
                    (sizeCalibration.current as HTMLSpanElement).textContent = (
                        e.currentTarget as HTMLInputElement
                    ).value;
                }}
                onChange={(e) => onUpdate((e.currentTarget as HTMLInputElement).value)}
                autoComplete="off"
            />
            {icon && (
                <ExIconButton
                    className="autosize-input-indicator-icon"
                    icon={icon}
                    flavor={IconButtonFlavor.BRANDED}
                    type={IconButtonType.TERTIARY}
                    onClick={() =>
                        autosizeInputRef.current &&
                        (autosizeInputRef.current as HTMLInputElement).focus()
                    }
                    hide-browser-tooltip
                />
            )}
        </div>
    );
};

export default AutosizeInput;
